export enum Currency {
  USD = 'USD',
  EUR = 'EUR',
  JPY = 'JPY',
  TWD = 'TWD',
}

export type CurrencyProperties = {
  flag: string;
  symbol: string;
  decimals: number;
};

export const currenciesProperties: Record<Currency, CurrencyProperties> = {
  [Currency.USD]: { flag: 'us', symbol: '$', decimals: 2 },
  [Currency.EUR]: { flag: 'eu', symbol: '€', decimals: 2 },
  [Currency.JPY]: { flag: 'jp', symbol: '¥', decimals: 0 },
  [Currency.TWD]: { flag: 'tw', symbol: 'NT$', decimals: 2 },
};

export const ORDERED_CURRENCIES: readonly Currency[] = [
  Currency.USD,
  Currency.EUR,
  Currency.JPY,
  Currency.TWD,
];

export function getCurrencyFlag(currency: Currency): string {
  return currenciesProperties[currency].flag;
}

export function getCurrencySymbol(currency: Currency): string {
  return currenciesProperties[currency].symbol;
}

export function formatPrice(currency: Currency, amount: number, decimals: boolean): string {
  const digits = decimals ? currenciesProperties[currency].decimals : 0;
  const rounded = (Math.ceil(amount * Math.pow(10, digits)) / Math.pow(10, digits));
  return `${amount < 0 ? '-' : ''}${getCurrencySymbol(currency)}${Math.abs(rounded).toFixed(digits)}`;
}
